var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _path10, _g3, _path11, _g4, _path12, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.116 32.6913C23.7713 34.3433 22.0439 35.5676 20.4434 36.3679V38.7172C23.7634 37.283 25.7364 35.3814 26.2079 33.1271C26.6357 31.0709 27.7649 29.5772 29.2189 28.4917L27.5113 27.1011C25.7364 28.567 24.5875 30.4449 24.116 32.6913Z",
    fill: "#29ABE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_19160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 36,
    width: 4,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.3879H3.5934V41.4591H0V36.3879Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_19160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126 39.6802C0.236932 40.8489 1.61566 41.2094 3.23606 41.3521V37.3149C1.16797 37.9092 0.0190298 38.5471 0.126 39.6802Z",
    fill: "#29ABE2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4398 24.0387C34.3962 24.1853 34.3487 24.3359 34.3091 24.4825L36.084 25.9246C37.221 25.7503 38.263 25.675 39.0712 25.6433L34.9628 23.9397C34.7885 23.9714 34.6141 24.0031 34.4398 24.0387Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5343 43.095C26.7182 44.3232 27.055 45.9793 28.2871 46.7954C28.7387 47.0965 29.2498 47.2391 29.7569 47.2391C30.6246 47.2391 31.4724 46.8192 31.9875 46.0427C34.947 41.5737 35.9533 37.4534 36.0484 34.0422L30.0382 29.1572C31.0485 32.3029 31.409 37.2434 27.5343 43.095Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4897 22.5609C26.351 23.599 26.4421 24.423 26.6917 25.0847C26.8225 25.6393 27.1275 26.1583 27.603 26.5426L37.262 34.395L40.7642 45.4526C41.1248 46.5896 42.1747 47.3186 43.3078 47.3186C43.5772 47.3186 43.8466 47.279 44.116 47.1918C45.5224 46.7481 46.299 45.2465 45.8552 43.8401L42.1113 32.0219C41.9528 31.5227 41.6517 31.0829 41.2476 30.7541L33.7518 24.6607C33.8587 24.2487 33.9855 23.8367 34.1281 23.4246C33.7201 23.0364 33.4625 22.4976 33.4427 21.9152L33.1377 13.3219C33.0941 12.1096 34.0449 11.0874 35.2573 11.0438C35.281 11.0438 35.3088 11.0438 35.3365 11.0438C36.5251 11.0438 37.4917 11.9749 37.5353 13.1634L37.6463 16.3369C37.8127 16.0516 37.9711 15.7743 38.1217 15.5128C39.3816 13.6943 39.437 11.024 37.8523 10.0137C37.674 9.89885 37.4799 9.79981 37.2738 9.71661C37.2501 9.70472 37.2223 9.68888 37.1986 9.67699C37.0916 9.63341 36.1091 9.23326 34.7264 9.01536C32.4404 8.65087 29.0688 8.78557 26.8344 11.8639C26.351 12.5295 26.4144 13.4487 26.9849 14.0469L28.3716 15.5009L28.7242 15.8694C27.7258 17.7988 27.0721 19.8154 26.4897 22.5609Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7123 26.0195C46.0729 25.1479 45.6608 24.1455 44.7892 23.785L37.3092 20.6789L37.0438 13.1831C37.0081 12.2401 36.2118 11.5032 35.2729 11.5349C34.3299 11.5706 33.593 12.359 33.6287 13.3019L33.9337 21.8991C33.9575 22.5687 34.3695 23.159 34.9876 23.4165L43.4779 26.9426C43.6918 27.0297 43.9137 27.0733 44.1316 27.0733C44.8011 27.0733 45.439 26.6771 45.7123 26.0195Z",
    fill: "#29ABE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9964 6.92739C49.3847 6.1786 47.8752 4.61763 45.6249 3.44888C45.5496 3.40926 45.4743 3.37361 45.3951 3.33399C45.0227 2.17316 44.2105 1.151 43.0417 0.54484C40.6844 -0.683335 37.7843 0.235816 36.5562 2.58916C35.332 4.9425 36.2471 7.84654 38.6044 9.07076C40.7637 10.1959 43.3824 9.51448 44.7453 7.57714C44.3729 7.35923 43.9886 7.10567 43.6043 6.82438C41.5996 5.35057 40.3596 3.61924 40.7914 2.91007C40.7399 3.71829 42.1662 5.10098 44.2144 6.16671C45.7596 6.97097 47.2532 7.383 48.1644 7.31961C48.5764 7.28792 48.8736 7.16114 48.9964 6.92739Z",
    fill: "#29ABE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5778 15.39C18.5778 13.5794 17.1119 12.1135 15.3013 12.1135H8.38393C6.57336 12.1135 5.10352 13.5794 5.10352 15.39V17.8503H18.5778V15.39Z",
    fill: "#29ABE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3836 41.5104C18.9304 41.5104 19.4414 41.6412 19.901 41.871V18.397H3.78418V41.871C4.23979 41.6412 4.75483 41.5104 5.30157 41.5104C7.04083 41.5104 8.47502 42.8258 8.67311 44.5135H15.0081C15.2062 42.8258 16.6444 41.5104 18.3836 41.5104ZM9.8379 20.3541H18.4866V22.3549H9.8379V20.3541Z",
    fill: "#29ABE2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6821 20.9443H17.8048V21.7644H12.6821V20.9443Z",
    fill: "#29ABE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_19160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 41,
    width: 8,
    height: 7
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56445 41.459H8.6641V48H1.56445V41.459Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_19160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46387 44.9096C2.46387 46.4746 3.73562 47.7424 5.30056 47.7424C6.86549 47.7424 8.13328 46.4746 8.13328 44.9096C8.13328 43.3447 6.86549 42.0769 5.30056 42.0769C3.73562 42.0769 2.46387 43.3447 2.46387 44.9096ZM5.30056 43.3051C6.18405 43.3051 6.90511 44.0222 6.90511 44.9096C6.90511 45.7971 6.18405 46.5181 5.30056 46.5181C4.4131 46.5181 3.69204 45.7971 3.69204 44.9096C3.69204 44.0222 4.4131 43.3051 5.30056 43.3051Z",
    fill: "#29ABE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_19160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 41,
    width: 8,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 41.459H21.8496V48H14.75V41.459Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_19160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3835 42.0769C16.8186 42.0769 15.5508 43.3447 15.5508 44.9096C15.5508 46.4746 16.8186 47.7424 18.3835 47.7424C19.9484 47.7424 21.2162 46.4746 21.2162 44.9096C21.2162 43.3447 19.9484 42.0769 18.3835 42.0769ZM18.3835 46.5181C17.4961 46.5181 16.779 45.7971 16.779 44.9096C16.779 44.0222 17.4961 43.3051 18.3835 43.3051C19.271 43.3051 19.9881 44.0222 19.9881 44.9096C19.9881 45.7971 19.271 46.5181 18.3835 46.5181Z",
    fill: "#29ABE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_19160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 26,
    width: 26,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1621 26.2454H69.2209V46.5301H44.1621V26.2454Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_19160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1129 45.1396H63.6003L53.8185 35.128L54.0602 34.8943L52.7092 33.5116L52.4675 33.7453L45.7442 26.8596C45.4946 27.129 45.1817 27.3311 44.833 27.446L51.7108 34.4862L51.4731 34.7199L52.8241 36.1026L53.0618 35.8689L62.1146 45.1396H58.0181C57.6377 45.1396 57.3247 45.4526 57.3247 45.833C57.3247 46.2133 57.6377 46.5263 58.0181 46.5263H68.1129C68.4932 46.5263 68.8062 46.2133 68.8062 45.833C68.8062 45.4526 68.4932 45.1396 68.1129 45.1396Z",
    fill: "#29ABE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_19160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 46,
    width: 12,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3477 46.5303H68.5042V48.0001H57.3477V46.5303Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_19160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8037 46.9817H68.3264V47.9959H57.8037V46.9817Z",
    fill: "#29ABE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurIcon2);
export default __webpack_public_path__ + "static/media/our-icon-2.686a3dd45f7a4b092a6a2e2cf8feabf6.svg";
export { ForwardRef as ReactComponent };